import { Injectable } from '@angular/core';

export type AppTheme = 'magenta' | 'green-dark' | 'blue-dark' | 'blue-light';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private storageKey = 'app.theme';
  private host: HTMLElement = document.documentElement;
  private readonly classes: Record<AppTheme, string> = {
    magenta: 'theme-magenta',
    'green-dark': 'theme-green-dark',
    'blue-dark': 'theme-blue-dark',
    'blue-light': 'theme-blue-light',
  } as const;

  getActiveTheme(): AppTheme {
    const stored = localStorage.getItem(this.storageKey) as AppTheme | null;
    return stored ?? 'blue-light';
  }

  applyTheme(theme: AppTheme): void {
    Object.values(this.classes).forEach((c) => this.host.classList.remove(c));
    this.host.classList.add(this.classes[theme]);
    localStorage.setItem(this.storageKey, theme);
  }
}
